/**
 * @desc OMS企业订单修改渠道
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderUpdateChannelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/updateCustomerOrderChannel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
